import React, { useState } from "react";
import { FaSpinner, FaTrash, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { BsExclamationLg } from "react-icons/bs";
import {
  deleteWithdrawal,
  fetchWithdrawal,
} from "../../../redux/slices/withdrawalSlice";
import { pushNotifyDriver } from "../../../redux/slices/pushSlice";

export default function DeleteDriverWithdrawal({ id, name, driver_id, amount }) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const status = useSelector((state) => state.withdrawal?.status);
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      const res = await dispatch(deleteWithdrawal(id));
      if (res.payload) {
        const pushNote = {
          driver_id: [driver_id],
          title: "Capfields Evolve",
          body: "Your withdrawal request has been deleted.",
          click: "DRIVER",
        };
        await dispatch(pushNotifyDriver(pushNote));
        toast.success(res.payload.message || "Withdrawal deleted successfully.");
        dispatch(fetchWithdrawal());
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete withdrawal.");
    }

    setShowDeleteModal(false);
  };

  return (
    <>
      <div className="flex items-center">
        <button type="button" onClick={() => setShowConfirmModal(true)}>
          <FaTrash className="text-red-600 text-2xl" />
        </button>
      </div>

      {showConfirmModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto">
            <div className="relative w-auto max-w-3xl mx-auto">
              <div className="bg-white p-8 rounded-lg shadow-lg relative">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                >
                  <FaTimes />
                </button>
                <div className="text-center">
                  <h2 className="text-xl font-medium text-gray-800 mb-2">
                    Are you sure?
                  </h2>
                  <p className="text-gray-600">
                    Do you really want to{" "}
                    <span className="text-red-600 font-semibold">
                      delete this withdrawal
                    </span>
                    ?
                  </p>
                </div>
                <div className="flex justify-center mt-6 gap-4">
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      setShowConfirmModal(false);
                      setShowDeleteModal(true);
                    }}
                    className="px-4 py-2 text-sm font-semibold text-white bg-red-600 rounded-md"
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}

      {showDeleteModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto">
            <div className="relative w-auto max-w-5xl mx-auto">
              <div className="bg-white p-8 rounded-lg shadow-lg relative">
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                >
                  <FaTimes />
                </button>
                <div className="text-center mb-4">
                  <h1 className="text-2xl mb-2 text-gray-800 font-medium">
                    Confirm Deletion
                  </h1>
                  <p>Do you want to delete this withdrawal request?</p>
                </div>
                <div className="flex justify-center items-center m-4">
                  <BsExclamationLg className="text-gray-500 text-3xl font-bold" />
                </div>
                <div className="flex justify-center items-center px-8 py-4 gap-6">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-row gap-2 justify-center items-center">
                      <h1 className="text-[14px] text-left text-gray-400">
                        Name:
                      </h1>
                      <p className="text-base font-bold">{name}</p>
                    </div>
                    <div className="flex flex-row gap-2 justify-center items-center">
                      <h1 className="text-[14px] text-left text-gray-400">
                        Amount:
                      </h1>
                      <p className="text-base font-bold">&#8358;{amount}</p>
                    </div>
                    <div className="flex mt-2 gap-4 justify-center">
                      <button
                        onClick={() => setShowDeleteModal(false)}
                        className="text-sm text-gray-500 font-semibold bg-gray-100 py-2 px-4 rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        className="flex gap-1 items-center bg-red-600 text-white py-2 px-4 rounded-md"
                        disabled={status === "loading"}
                        onClick={handleDelete}
                      >
                        {status === "loading" ? (
                          <>
                            <FaSpinner className="animate-spin" />
                            <span className="text-sm font-semibold">Deleting...</span>
                          </>
                        ) : (
                          <>
                            <FaTrash />
                            <span className="text-sm font-semibold">Delete</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}
    </>
  );
}
